import { VictoryAxis, VictoryChart, VictoryLine, VictoryTooltip, VictoryVoronoiContainer } from 'victory'

type XValue = number | string | Date
type LineChartPoint = { x: XValue; y: number }

type Props = {
  data: LineChartPoint[]
  width?: number
  height?: number
  strokeColor?: string
  animate?: boolean
  xTickValues?: XValue[]
  xTickFormat?: ((tick: XValue) => string) | string[]
  yTickFormat?: ((tick: XValue) => string) | string[]
  tooltipFormatter?: (point: LineChartPoint) => string
}

const LineChart: React.FC<Props> = ({
  data,
  width = 960,
  height = 540,
  strokeColor = '#009ef7',
  animate = true,
  xTickValues,
  xTickFormat,
  yTickFormat,
  tooltipFormatter
}) => {
  const fontFamily = 'Poppins, Helvetica, sans-serif'
  const gridColor = '#e9ecef'
  const formatTooltip = tooltipFormatter ?? ((point: LineChartPoint) => point.y.toString())

  return (
    <>
      <VictoryChart
        animate={animate ? { duration: 1000, onLoad: { duration: 1 } } : false}
        width={width}
        height={height}
        containerComponent={
          <VictoryVoronoiContainer
            labels={({ datum }) => formatTooltip(datum as LineChartPoint)}
            labelComponent={
              <VictoryTooltip
                style={{ fontFamily: fontFamily, fontSize: 12 }}
                flyoutStyle={{ stroke: '#dfe2e6', fill: '#fff' }}
              />
            }
          />
        }>
        <VictoryLine style={{ data: { stroke: strokeColor } }} data={data} />
        <VictoryAxis
          tickValues={xTickValues}
          tickFormat={xTickFormat}
          style={{ tickLabels: { fontFamily: fontFamily, fontSize: 16 } }}
          animate={false}
        />
        <VictoryAxis
          dependentAxis
          animate={false}
          tickFormat={yTickFormat}
          style={{
            tickLabels: { fontFamily: fontFamily, fontSize: 16 },
            grid: { stroke: gridColor, strokeDasharray: '10,5' }
          }}
        />
      </VictoryChart>
    </>
  )
}
export { LineChart }
